// src/components/About/index.js
import React, { Component } from 'react';
import AdminHeader from '../AdminHeader';
import UserRow from './UserRow';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow} from 'material-ui/Table';
var CompanyService = require('../../service/companies');
var BaseService = require('../../service/baseservice');
import './style.css';

export default class UsersPage extends Component {

  state = {
    dataUpdated: null
  }

  dataUpdated(data) {
    this.setState({dataUpdated: new Date()});
  }

  componentDidMount() {
    BaseService.addListener(this.dataUpdated.bind(this));
  }

  render() {
    var rows = BaseService.fetchedData.users.map(user => <UserRow user={user} key={user._id}/>);

    return (
      <div>
        <AdminHeader selected="users"/>
        <div style={{marginLeft:'24px', width:'900px'}}>
          <Table
            multiselectable={false}>
            <TableHeader
                displaySelectAll={false}
                adjustForCheckbox={false}
                enableSelectAll={false}>
                <TableRow>
                  <TableHeaderColumn>Nimi</TableHeaderColumn>
                  <TableHeaderColumn>Sähköposti</TableHeaderColumn>
                  <TableHeaderColumn>Admin</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false} stripedRows={false}>
                {rows}
              </TableBody>
          </Table>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UsersPage/UsersPage.js